/* global CVP, Aspen */

// ## AspenController
//
// Reports progress to Aspen.

'use strict';

var App = require('./app');
var _ = require('./vendor/underscore');
var _logger = require('./logger');
var Dom = require('./dom');
var MVPDConfig = require('./mvpdconfig');


if (_.isUndefined(Aspen) || !_.isFunction(Aspen.createInstance)) {
	_logger.error('AspenController - Aspen was not found - cvp.js must be installed prior to cvp.auth.js');
	return ({
		send: _.noop,
		init: _.noop
	});
}

var aspen = Aspen.createInstance({
	aspenAppSignature: {
		applicationName: 'auth',
		applicationVersion: App.VERSION,
		context: 'default',
		deviceModel: 'desktop',
		deviceType: 'desktop',
		deviceVersion: 'desktop',
		platformName: 'javascript',
		platformVersion: CVP.Browser.version ? String(CVP.Browser.version) : undefined
	}
});

var auth = null;
var inited = false;
var regcode;

var commonMsgProps = {
	// to be filled in later
};

function send(type, obj) {
	var data = _.extend({}, commonMsgProps, obj);

	// FIXME: Aspen swapped these params .. but leaving as-is for now to test.
	aspen.send(data, type);
}


var initHeartbeat = CVP.Utils.Timing.periodically(CVP.Utils.bind(send, null, 'adobeInitHeartbeat'), 10000);

var authZHeartbeat = (function () {
	var SECOND = 1000;
	var MINUTE = 60 * SECOND;
	var heartbeatTimer = null;
	var heartbeatDelay = 10 * SECOND;
	var aspenPayload = null;

	function determineHeartbeatDelay(delay) {
		if (delay < MINUTE) {
			return delay + 10 * SECOND;
		}

		if (delay < 5 * MINUTE) {
			return delay + 30 * SECOND;
		}

		return delay + MINUTE;
	}

	function heartbeat() {
		_logger.debug('AspenController - heartbeat', heartbeatDelay + ' ms have passed');
		send('authorizationHeartbeat', aspenPayload);
		heartbeatDelay = determineHeartbeatDelay(heartbeatDelay);
		wait();
	}

	function wait() {
		heartbeatTimer = window.setTimeout(heartbeat, heartbeatDelay);
	}

	function clear() {
		if (heartbeatTimer) {
			window.clearTimeout(heartbeatTimer);
			heartbeatTimer = null;
		}
	}

	function start(authZData) {
		clear();
		aspenPayload = authZData;
		wait();
	}

	function stop() {
		clear();
		aspenPayload = null;
	}

	return ({
		start: start,
		stop: stop
	});
}());


function adobeInitAttempt(obj) {
	// clientVersion = client version constant from Adobe's headers
	// requestor = property name
	// mvpdConfig = mvpd config url
	// staging = boolean
	send('adobeInit', {
		clientVersion: obj.adobeVersion,
		requestorID: obj.requestorId,
		mvpdConfig: obj.mvpdConfigUrl,
		staging: obj.adobeStaging
	});

	initHeartbeat.start();
}

function adobeInitSuccess(obj) {
	send('adobeInitSuccess', {
		requestorID: obj.requestorId,
		serverUrl: obj.adobeUrl
	});

	initHeartbeat.stop();
}

function adobeInitFailure() {
	send('adobeInitFailure', {});

	initHeartbeat.stop();
}

function mvpdConfigLoadAttempt(obj) {
	send('mvpdConfigLoadAttempt', {
		requestorID: obj.requestorId,
		url: obj.mvpdConfigUrl
	});
}

function mvpdConfigLoadSuccess() {
	send('mvpdConfigLoadSuccess', {});
}

function mvpdConfigLoadFailure() {
	send('mvpdConfigLoadFailure', {});
}

function darkPhaseLoadAttempt(obj) {
	send('darkPhaseLoadAttempt', {
		url: obj.darkPhaseUrl
	});
}

function darkPhaseLoadSuccess() {
	send('darkPhaseLoadSuccess', {});
}

function darkPhaseLoadFailure() {
	send('darkPhaseLoadFailure', {});
}

function regCodeInvalid(obj) {

	// Clear cached regcode
	regcode = undefined;

	send('invalidRegcode', {
		regCode: obj.regCode
	});

}

function regCodeValid(obj) {

	// Store cached regcode
	regcode = obj.regCode;

	send('validRegcode', {
		regCode: obj.regCode
	});

}

function authNAttempt(obj) {
	send('authenticationAttempt', {
		mvpdID: obj.id,
		regCode: regcode,
		requestorID: auth.getRequestorId()
	});
}

// invoked from sendTrackingData response where
//   trackingEventType == TRACKING_AUTHENTICATION
//   and arg[0] == true
//   and arg[3] == false/NO
function authNSuccess(obj) {
	send('authenticationSuccess', {
		mvpdID: obj.mvpdID,
		userID: obj.userID,
		requestorID: auth.getRequestorId()
	});
}

function statusUpdate(obj) {
	if (obj.eventType === 'authenticationDetection'
		&& obj.trackingData[0] === true
		&& obj.trackingData[3] === false)
	{
		authNSuccess({
			mvpdID: obj.trackingData[1],
			userID: obj.trackingData[2]
		});
	}
}

function authZAttempt(obj) {
	var data = {
		mvpdID: obj.mvpdId,
		requestorID: auth.getRequestorId(),
		resource: obj.resource
	};

	send('authorizationAttempt', data);

	authZHeartbeat.start(data);
}

function authZSuccess(obj) {
	send('authorizationSuccess', {
		mvpdID: obj.mvpdId,
		requestorID: auth.getRequestorId(),
		resource: obj.resource
	});

	authZHeartbeat.stop();
}

function authZFailure(obj) {
	send('authorizationFailure', {
		mvpdID: obj.mvpdId,
		requestorID: auth.getRequestorId(),
		resource: obj.resource,
		errorCode: obj.errorCode,
		errorDescription: obj.errorString
	});

	authZHeartbeat.stop();
}

function providerList(obj) {
	var mvpdNames = _.pluck(obj.mvpds, App.MVPD_ID_KEY).join(',');

	send('providerList', {
		list: mvpdNames
	});
}

function adobeEvent(obj) {
	send('adobeEvent', obj);
}

function logout() {
	send('logout', {});
}

var authHandlers = (function () {

	var handlers = {

		'adobeInitAttempt': adobeInitAttempt,
		'adobeInitSuccess': adobeInitSuccess,
		'adobeInitFailure': adobeInitFailure,

		'registrationCodeInvalid': regCodeInvalid,
		'registrationCodeValid': regCodeValid,

		'setSelectedProvider': authNAttempt,
		'sendTrackingData': statusUpdate,

		'checkAuthorization': authZAttempt,
		'setToken': authZSuccess,
		'tokenRequestFailed': authZFailure,

		'displayProviderDialog': providerList,
		'adobeError': adobeEvent,
		'logout': logout

		// 'cancelLogin' is handled by AuthManager
	};

	return function enableAuthHandlers(onOrOff) {
		var handler;

		if (!auth) {
			return;
		}

		for (var name in handlers) {
			if (!_.has(handlers, name)) {
				continue;
			}
			handler = handlers[name];
			auth[onOrOff](name, handler);
		}
	};

}());

var mvpdConfigHandlers = (function () {

	var handlers = {

		'mvpdConfigLoadAttempt': mvpdConfigLoadAttempt,
		'mvpdConfigLoadSuccess': mvpdConfigLoadSuccess,
		'mvpdConfigLoadFailure': mvpdConfigLoadFailure,

		'darkPhaseLoadAttempt': darkPhaseLoadAttempt,
		'darkPhaseLoadSuccess': darkPhaseLoadSuccess,
		'darkPhaseLoadFailure': darkPhaseLoadFailure

	};

	return function enableMvpdConfigHandlers(onOrOff) {
		var handler;

		for (var name in handlers) {
			if (!_.has(handlers, name)) {
				continue;
			}
			handler = handlers[name];
			MVPDConfig[onOrOff](name, handler);
		}
	};

}());

function destroy() {
	authHandlers('off');
	mvpdConfigHandlers('off');
}

function init(options, authInstance) {
	if (inited) {
		// disallow subsequent init()s
		return;
	}

	inited = true;
	auth = authInstance;

	_logger.log('AspenController - init', options);

	var aspenInitConfig = {};
	aspenInitConfig.site          = options.site;
	aspenInitConfig.context       = options.aspenContext || options.context;
	aspenInitConfig.configBaseUrl = options.configBaseUrl;
	aspenInitConfig.dt            = options.superduperdevtime;

	aspen.init(aspenInitConfig);

	authHandlers('on');
	mvpdConfigHandlers('on');

	// clean up on death
	Dom.on(window, 'unload', destroy);
}


exports.send = send;
exports.init = init;
